import React from 'react'
import { exploreStyles as styles } from './exploreTokensAccessibility.tailwind'
import golden_box from '../../../assets/svgs/golden_box.svg'
import explore_tokens from '../../../assets/svgs/curve_text.svg'
import { useNavigate } from 'react-router-dom'
import routeConstant from '../../../lib/constants/routeConstant'
import { useSelector } from 'react-redux'
import { storage } from '../../../config/storage'

const ExploreTokensAccessibility = () => {
  const navigate = useNavigate();
  const { isSignedIn } = useSelector((state) => state.user)

  const handleExploreTokens = () => {
    if(!isSignedIn){
      // set to local-storage to navigate on this page if not loginned
      storage.setInLocalStorage.navigateOnLogin(routeConstant.SELECT_SPORT_PAGE);
    }
    navigate(routeConstant.SELECT_SPORT_PAGE)
  }

  return (
    <div className={styles.container} onClick={handleExploreTokens}>
        <img src={explore_tokens} alt="Explore Tokens" className={styles.explore_token} />
        <img src={golden_box} alt="Golden Box" className={styles.golden_box} style={{ animation: "bounce 4s infinite" }} />
    </div>
  )
}

export default ExploreTokensAccessibility